import { useLazyQuery } from "@apollo/client/react";
import { useEffect, useState } from "react";
import { adaptDetalleConexionesArray, GET_GRILLA_CONEXIONES_DETALLE } from "../../../data/graphQL/queries/AdminConexiones/getGrillaConexionesDetalle";


export const useGetConexionesDetalleRows = (idEvaluacion, month, year) => {
  const [rows, setRows] = useState([]);

  const [getConexionesDetalle, { data: dataConexionesDetalle, loading: conexionesDetalleLoading }] = useLazyQuery(GET_GRILLA_CONEXIONES_DETALLE, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataConexionesDetalle) return;
    const dataAdapted = adaptDetalleConexionesArray(dataConexionesDetalle);
    setRows(dataAdapted);
  }, [dataConexionesDetalle]);

  const handleSearch = () => {
    getConexionesDetalle({
      variables: {
        input: {
          idEvaluacion,
          mes: parseInt(month, 10),
          anio: parseInt(year, 10)
        }
      }
    });
  };

  useEffect(() => {
    handleSearch();
  }, [idEvaluacion, month, year]);

  return {
    rows,
    setRows,
    totalCount: rows.length || 0,
    loading: conexionesDetalleLoading,
    handleSearch
  };

};